<template>
<div class="default-vue">

    <div v-if="loading">
            <!-- placeholder images -->
            <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Overview_Placeholder_Desktop_v1.svg" style="width:1400px" alt="">
            <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Overview_Placeholder_Tablet_v1.svg" alt="">
            <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Overview_Placeholder_Mobile_v1.svg" alt="">
        </div>
    <div v-if="!loading">
         <!--special days details-->
        <div class="with-sidebar-content  gdlr-item-start-content columns">  
            <!--special days details-->
            <div v-if="specialDaysSessions && specialDaysSessions.length">
                <!-- mobile filters Start  -->
                <div class="visible-xs visible-sm col-xs-12 session-item-filter session-item-filter-mobile">
                    <nav class="navbar" role="navigation">
                        <div class="container-fluid-mobile">
                            <form id="filtering-form" v-on:submit="getfilteredData">
                                <div class="form-group">
                                    <a name="search" id="search">
                                        <div class="col-xs-12 col-sm-6 filter-on-right-side-blocks-mobile">
                                            <div v-if="typesFromQuery && typesFromQuery.length" class="filter-on-right-side-blocks filter-on-right-side-first">
                                                <div>
                                                    <h3>{{ $t('filter-by') }}</h3>
                                                    <label class="">{{ $t('sessionType') }}</label>
                                                    <select class="filterSelectVue postform selectpicker" name="type" v-model="typeToFilter">
                                                        <option default value="ALL">{{ $t('all-types') }}</option>
                                                        <option v-for="(aType, index) in typesFromQuery" :value="aType._id" :key="index">{{aType.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </form>
                        </div>
                    </nav>
                </div>
                <!-- mobile filters Ends  -->

                <!--sessions display-->
                <div class="col-xs-12 col-sm-12 col-md-9  session-item-wrapper">
                    <div :style="{'background-color':editionBgColor}" class="h3 special-days-boxheadline mlc-location-independent-block-invisible">
                            <span v-if="showLanguageFlag && boxheadlineDe">{{boxheadlineDe}}</span>
                            <span v-if="!showLanguageFlag && boxheadlineEn">{{boxheadlineEn}}</span>
                    </div>
                    <div class="col-xs-12 sands-item-title-wrapper-custom"></div>
                        <div class="row">
                            <div class="gdlr-session-item gdlr-full-session-item gdlr-item"
                                id="timetable-overview-custom">
                                <div class="gdlr-session-item-head gdlr-first onTop " :class="{'thisisthefirstdivider': index == 0,'onTop{{index}}' : true,'full-width-time-table': getOneSessionTime().length == 1}">
                                    <div v-for="(aDayTime, aDayTimeIndex) in getOneSessionTime()" :key="aDayTimeIndex" class="table-head-link sigle-day-active aDayLink padding-program-day-display" :class="{'sigle-day-not-active': index > 0 && index != aDayTimeIndex, [getaDayTimeIndex(aDayTimeIndex)] : true}" :href="'#programJumpToDay'+aDayTimeIndex">
                                        <div v-if="showTimeAndDate" class="gdlr-session-item-head-info" :class="{'sands-active': index == aDayTimeIndex,'sands-not-active' : index != aDayTimeIndex}">
                                            <p class="gdlr-session-head-weekday">{{getDay(aDayTime)}}</p>
                                            <div class="gdlr-session-head-date">{{aDayTime}}</div>
                                        </div>
                                    </div>
                                </div>
                        <div v-if="specialDaysSessions && specialDaysSessions.length">
                        <div v-for="(aDay, index) in getSessions()" :key="index" :id="'programJumpToDay'+index">
                            <div v-for="(session, sessionIndex) in sortSessionsByDate(aDay.sessions)" :key="sessionIndex">
                                <div v-if="sessionstyle != 'small' && session.type == 'Break'" class="gdlr-session-item-content-wrapper break-parent-container">
                                    <div class="session-break-content">
                                        <div class="session-break-info">
                                            <span v-if="showTimeAndDate && session.localizedStartDate">
                                                {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}
                                            </span>
                                            <h3 class="gdlr-session-break-title">{{session.name}}</h3>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                                <div v-if="session.type != 'Break'" class="gdlr-session-item-content-wrapper">
                                    <div v-if="showTimeAndDate && session.localizedStartDate && sessionstyle != 'small'" class="gdlr-session-item-content-info">
                                        <div class="col-xs-3 session-type-icons"></div>
                                        <div v-if="session.localizedStartDate && session.localizedEndDate" class="col-xs-12 col-md-12 session-date_info">
                                            <div class="gdlr-session-info">
                                                <div class="session-info session-time">
                                                    {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="gdlr-session-item-content">
                                         <div class="column hidden-xs speakers-image two vue">
                                        <div v-if="session && session.experts" class="column gdlr-session-thumbnail-wrapper">
                                            <div v-for="(expert, index) in session.experts" :key="index" class="gdlr-speaker-thumbnail">
                                                <div class="gdlr-speaker-thumbnail-inner resize">
                                                    <a v-if="expert && expert.slug" :href="'/speaker/'+expert.slug">
                                                        <div v-if="expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                                            <img :src="expert.avatarSquareSmall.xxxx" :alt="expert.surname" width="150" height="150">
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        <div class="sessoin-speaker-title column ten">
                                             <div class="session-type-icons">
                                            <div class="cathead-img">
                                                <div class="session-type-badge session-type-badge-styling cathead-img" :style="{'background-color':session.sessionType.colourHexCode}">
                                                    <p class="session-type-name session-type-name-color">{{session.sessionType.type}}</p>
                                                </div>
                                            </div>
                                            <div v-if="showLanguageFlag && session.language && session.language == 'EN'" class="session-language-flag-icon-timetable en">en</div>
                                            <div v-if="showLanguageFlag && session.language && session.language == 'DE'" class="session-language-flag-icon-timetable de">de</div>
                                        </div>
                                            <h3 v-if="session.name" class="gdlr-session-item-title">
                                                <a v-if="session.primaryTrack && session.primaryTrack.slug && session.slugNames && session.slugNames.length" :href="'/'+session.primaryTrack.slug+'/'+session.slugNames[0]">{{session.name}}</a>
                                                <span v-else>{{session.name}}</span>
                                            </h3>
                                            <div v-for="(expert, index) in session.experts" :key="index" class="twelve columns speakers-name-and-company">
                                                <a v-if="expert && expert.surname && expert.forename && expert.slug" :href="'/speaker/'+expert.slug">
                                                    {{expert.forename}}  {{expert.surname}}<span v-if="expert && expert.company">, &nbsp;<em> {{expert.company}}</em></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div class="stop-fixed-header"></div>
            <div class="mlc-location-independent-block-invisible">
                <a :href="programbuttonLinkeDe" v-if="showLanguageFlag" class="medium light-button gdlr-button rounded-corner-buttons text-center rounded-s" :style="{'background-color':editionBgColor}">
                <span>Alle Sessions ansehen</span>
                </a>
                <a :href="programbuttonLinkEn" v-if="!showLanguageFlag" class="medium light-button gdlr-button rounded-corner-buttons text-center rounded-s" :style="{'background-color':editionBgColor}">
                    <span>View All Sessions</span>
                </a>
            </div>
        </div>
    </div>
    <!--sessions display-->

    <!--filters-->
    <div class="hidden-xs hidden-sm col-md-3 session-item-filter">
            <nav class="navbar" role="navigation" aria-label="Program Filter Navigation">
                <div class="container-fluid">
                    <form id="filtering-form-vue" v-on:submit="getfilteredData">
                        <div class="form-group">
                            <a name="search" id="search">
                            </a>
                                </div>
                                <div v-if="typesFromQuery && typesFromQuery.length" class="filter-on-right-side-blocks filter-on-right-side-first">
                                    <div class="bootstrap-select-vue custom-select-vue">
                                        <h3>{{ $t('filter-by') }}</h3>
                                        <label class="">{{ $t('sessionType') }}</label>
                                        <select class="filterSelectVue program-filter-select" name="type" v-model="typeToFilter">
                                            <option id="123" class="defaultFilterOption" selected="selected" value="ALL">{{ $t('all-types') }}</option>
                                            <option v-for="(aType, index) in typesFromQuery" :value="aType._id" :key="index">{{aType.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="widgetHtml" class="filter-on-right-side-blocks filter-on-right-side-third">
                                    <div class="addtional-after-filter-html">
                                        <div class="vhtml" v-html="widgetHtml">
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </nav>
                </div>
        <!--filters-->
            </div>
        </div>
    </div>
</div>
</template>


<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'

import moment from 'moment'

export default {
    name: 'SpecialDaysDetails',
    props: {
        settingsPerm: Object
    },
    components: {},
    data() {
        return {
            result: null,
            loading: true,
            error: true,
            seriesToDisplay: [],
            specialDayIds_in: this.specialDaysIds,
            conferenceBrandId: this.settingsPerm.conferenceBrandId,
            mlcactivelocation: this.settingsPerm.mlcactivelocation,
            seriesIds: this.settingsPerm.seriesIds,
            collectedSeries: null,
            activeLocation: null,
            days: null,
            weekDaysDate: [],
            widgetHtmlSet: false,
            widgetHtml: false,
            startDate: null,
            typesFromQuery: [],
            typeToFilter: 'ALL',
            filterType: null,
            specialDaysSessions: null,
            typeFilterMatch: false,
            showTimeAndDate: this.settingsPerm.showTimeAndDate,
            identifier: this.settingsPerm.identifier,
            loadingfilter: true,
            postSlug: this.settingsPerm.postSlug,
            postTitle: this.settingsPerm.postTitle,
            theOneAndOnlySpecialDay:false,
            showLanguageFlag: this.settingsPerm.showLanguageFlags,
            editionBgColor: this.settingsPerm.editionBgColor,
            boxheadlineDe: this.settingsPerm.boxheadlineDe,
            boxheadlineEn: this.settingsPerm.boxheadlineEn,
            programbuttonLinkeDe: this.settingsPerm.programbuttonLinkeDe,
            programbuttonLinkEn: this.settingsPerm.programbuttonLinkEn,
            locationprogrampageDe: this.settingsPerm.locationprogrampageDe,
            cookie: this.getCookie(),
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            manipulateSessionTime: this.settingsPerm.manipulateSessionTime,
            manipulateSessionTimeBy: 0
        }
    },
    created() {  
        this.loading = true;  
        if (this.conferenceBrandId) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: window.walkuere_app_data.concord_url,
            })
            provideApolloClient(apolloClient)
            let variablesForInstance = {
                conferenceBrandId: this.conferenceBrandId,
                id: this.seriesIds[0]
            };

            const {
                result
            } = useQuery(CONCORD_QUERIES.SPECIAL_DAYS_QUERY, variablesForInstance);
            watch(result, value => {

                if (result && value && value.vueSpecialDays && value.vueSpecialDays.Meta && value.vueSpecialDays.Meta.count && value.vueSpecialDays.Meta.count > 0) {
                    if (value.vueSpecialDays.SpecialDays && value.vueSpecialDays.SpecialDays.length) {
                        let specialDaysUniqueId = [];
                        value.vueSpecialDays.SpecialDays.forEach(aSpecialDay => {
                            if (aSpecialDay && aSpecialDay.uniqueId && aSpecialDay.name == this.postTitle) {
                                this.theOneAndOnlySpecialDay = aSpecialDay;
                                specialDaysUniqueId.push(aSpecialDay.uniqueId);
                            }
                        });
                        if (specialDaysUniqueId && specialDaysUniqueId.length && specialDaysUniqueId.length > 0 && this.seriesIds && this.seriesIds.length) {
                            let variablesForSpecialSessions = {
                                id: this.seriesIds[0],
                                specialDaysUniqueId: specialDaysUniqueId,
                                conferenceBrandId: this.conferenceBrandId
                            };
                            const {
                                result
                            } = useQuery(CONCORD_QUERIES.SPECIAL_DAYS_DETAILS_QUERY, variablesForSpecialSessions); 
                            watch(result, value => {
                                if (result && value && value.vueSessions && value.vueSessions.Sessions && value.vueSessions.Sessions.length) {
                                    this.specialDaysSessions = value.vueSessions.Sessions;
                                    this.result = value;
                                    this.manipulateSessionTimeBy = this.manipulateSessionTime;
                                } 
                            });
                        }
                    this.loading = false;  
                    }

                }
                else{
                    this.loading = false;  
                }
            });
        }
    },
    methods: {
        getTime(localizedDate) {
            if (this.manipulateSessionTimeBy) {
            if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
            } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
            }
            } else {
                return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
            }
        },
        getDay(startDate) {
            return window.moment(startDate, 'DD. MMM YYYY').format('ddd');
        },
        sortSessionsByDate(sessions){
            let sortedSessions;
            if (sessions && sessions.length) {
                sortedSessions = sessions.sort((a,b) =>{
                    return window.moment(a.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') - window.moment(b.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x');
                })
            }
            return sortedSessions;
        },
        getSessions(){
             let weeKDaysAsDate = [];
            if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length) {
                if (this.typeToFilter || this.trackToFilter) {
                    let filteredSessions = [];
                    this.result.vueSessions.Sessions.forEach(aSession => {
                        let typeFilterMatches = true;
                        let trackFilterMatches = true;
                        if (this.typeToFilter && this.typeToFilter.length && this.typeToFilter != "ALL") {
                            typeFilterMatches = false;
                            if (aSession && aSession.sessionType && aSession.sessionType._id && aSession.sessionType._id === this.typeToFilter) {
                                typeFilterMatches = true;
                            }
                        }
                        if (this.trackToFilter && this.trackToFilter.length && this.trackToFilter != "ALL") {
                            trackFilterMatches = false;
                            if (aSession && aSession.trackIds && aSession.trackIds.length && aSession.trackIds.includes(this.trackToFilter)) {
                                trackFilterMatches = true;
                            }
                        }
                        if (typeFilterMatches && trackFilterMatches) {
                            filteredSessions.push(aSession);
                        }
                    });
                    if (filteredSessions && filteredSessions.length) {
                        filteredSessions.forEach(session => {
                            let startdate = window.moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                            weeKDaysAsDate.push({
                                startdate,
                                session
                            });
                        });

                    }
                } else {
                    this.result.vueSessions.Sessions.forEach(session => {
                        let startdate = window.moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                        weeKDaysAsDate.push({
                            startdate,
                            session
                        });
                    });
                }
            }
            const groupByTimes = (weeKDaysAsDate) => Object.values(weeKDaysAsDate.reduce((weeKDaysAsDate, {
                startdate,
                session
            }) => {

                if (weeKDaysAsDate[startdate]) {
                    weeKDaysAsDate[startdate].sessions.push(session);
                } else {
                    weeKDaysAsDate[startdate] = {
                        startdate,
                        sessions: [session]
                    };
                }
                return weeKDaysAsDate;
            }, {}));
            let weekDayGroup = groupByTimes(weeKDaysAsDate);
            if (weekDayGroup && weekDayGroup.length == 0) {
                this.noSessionsForFilter = true;
            } else {
                this.noSessionsForFilter = false;
            }
            return weekDayGroup;
        },
        getOneSessionTime() {
            let weekDaysDate = [];
            if (this.specialDaysSessions) {
                this.specialDaysSessions.forEach(session => {
                    let startdate = window.moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD. MMM YYYY');
                    if (!weekDaysDate.includes(startdate)) {
                        weekDaysDate.push(startdate);
                    }
                });
            }
            this.days = weekDaysDate.length;
            return weekDaysDate;
        },
        getaDayTimeIndex(index) {
            return 'aSingleDayHeaderLink' + index;
        },
         async getWidget() {

             let jQueryVue = window.jQuery;
             const resultt = await jQueryVue.ajax({
                 url: window.sands_ajax_object.ajaxurl,
                 type: 'get',
                 data: {
                     'action': 'get_widgetarea_content',
                     'href': window.location.href,
                     'title': document.title,
                 },
                 success: function (response) {
                     return response
                 }
             });
             return resultt;

         },
         displaywidget() {
            let thiz = this;
            if (!this.widgetHtml) {
                 this.getWidget().then((data) => {
                     thiz.widgetHtml = data;
                 })
             }
         },
          getCookie() {
            return window.jQuery.cookie("event_location");
        },
        getSpecialDaysTime(localizedDate) {
            return window.moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('dddd');
        },
        getSpecialDaysDay(startDate) {
            return window.moment(startDate, 'DD/MM/YYYY HH:mm:ss').format('DD. MMM. YYYY');
        },
    },
      updated() {
        if (this.cookie && this.theMaybeSetPLLCookieValue) {
             this.cookie = window.jQuery.cookie("event_location");
            if (this.cookie && (typeof this.cookie !== "undefined") && (this.cookie != "") && (this.cookie != "all")) {
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).addClass('mlc-location-dependent-block-visible');
                window.jQuery('.mlc-location-dependent-block-invisible.' + this.cookie).removeClass('mlc-location-dependent-block-invisible');
            } else {
            // we do NOT have a location so we do somtehing with location dependend things
            window.jQuery('.mlc-location-independent-block-invisible').addClass('mlc-location-independent-block-visible');
            window.jQuery('.mlc-location-independent-block-invisible').removeClass('mlc-location-independent-block-invisible');
            }
            if (this.theMaybeSetPLLCookieValue && (typeof this.theMaybeSetPLLCookieValue !== "undefined") && (this.theMaybeSetPLLCookieValue != "") && (this.theMaybeSetPLLCookieValue == 'de')) {
                window.jQuery('.language-dependent-block-invisible-de').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible-de').removeClass('language-dependent-block-invisible-de');
            } else {
                window.jQuery('.language-dependent-block-invisible').addClass('language-dependent-block-visible');
                window.jQuery('.language-dependent-block-invisible').removeClass('language-dependent-block-invisible');
            }
        }
        if (!this.loadingfilter && window && window["makeFiltersSticky"]) {
              window["makeFiltersSticky"]();
          }
      },
      beforeUpdate() {
        if (this.specialDaysSessions && this.specialDaysSessions.length) {
            this.specialDaysSessions.forEach(aSession => {
                if (aSession && aSession.sessionType && aSession.sessionType.type && !this.typesFromQuery.includes(aSession.sessionType)) {
                    this.typesFromQuery.push(aSession.sessionType);
                }
                this.loadingfilter = false;
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.filterSelectVue {
    width: 100%;
    font-size: 16px;
}

.new-layout-session-type {
    padding: 7px 8px 5px 8px;
    background-color: #fff;
}

.program-filter-select {
    padding: 5px;
}

.p--l--3 {
    padding-left: 12px;
}

.m--t--0 {
    margin-top: 0px;
}
.special-days-boxheadline{
    font-weight: 600;
    padding: 5px 5px 10px 10px;
    margin-bottom:30px;
}
.padding-program-day-display{
    padding: 0px 10px 0px 10px;
}
.gdlr-speaker-thumbnail-inner.resize img{
    height: 60px;
    object-fit: cover;
}
.session-type-name-color {
    color: #fff;
    margin: 0;
    font-size: 19px;
    font-weight: 600;
}
select{
    background-color:#EBEBEB;
}
.filter-on-right-side-blocks{
    width: 100%!important;
}
.sday-detail-styling{
    font-size: 24px;
    padding: 25px;
}
.full-width-time-table .aDayLink, .full-width-time-table .aDayLink .gdlr-session-item-head-info{
    width: 100%;
}
</style>
